import { Stack, Text } from '@ltvco/refresh-lib/theme';

import { formatShorthandDate } from 'routes/SearchPerson/Cards/NewCardsDesignVariation1/common/utils';

import { AncestorReportSummaryData } from '../DataTypes/SummaryTypes';

import { BoldSpan } from './components';

interface GenealogyReportRendererProps {
  data: AncestorReportSummaryData;
}

export const GenealogyReportRenderer = ({
  data,
}: GenealogyReportRendererProps) => {
  return (
    <Stack spacing={3} py={2}>
      <Text>
        Here is what we found in the genealogy records for{' '}
        <BoldSpan>{data.personName}</BoldSpan>
      </Text>
      <Stack spacing={1.5}>
        <Text>
          <BoldSpan>Summary</BoldSpan>
        </Text>
        <Text>
          <BoldSpan>Age at Death:</BoldSpan> {data.age || '-'}
        </Text>
        <Text>
          <BoldSpan>Date of Birth:</BoldSpan>{' '}
          {data.dateOfBirth
            ? typeof data.dateOfBirth === 'string'
              ? data.dateOfBirth
              : formatShorthandDate(data.dateOfBirth)
            : '-'}
        </Text>
        <Text>
          <BoldSpan>Date of Death:</BoldSpan>{' '}
          {data.dateOfDeath
            ? typeof data.dateOfDeath === 'string'
              ? data.dateOfDeath
              : formatShorthandDate(data.dateOfDeath)
            : '-'}
        </Text>
      </Stack>
      <Stack spacing={1.5}>
        <Text>
          <BoldSpan>Background</BoldSpan>
        </Text>
        <Text>
          <BoldSpan>Place of Birth:</BoldSpan> {data.birthAddress || '-'}
        </Text>
        <Text>
          <BoldSpan>Place of Death:</BoldSpan> {data.deathAddress || '-'}
        </Text>
      </Stack>
      <Stack spacing={1.5}>
        <Text>
          <BoldSpan>Relatives</BoldSpan>
        </Text>
        {data.relatives.length > 0 ? (
          data.relatives.map((relative) => (
            <Text key={relative}>• {relative}</Text>
          ))
        ) : (
          <Text>-</Text>
        )}
      </Stack>
    </Stack>
  );
};
